import React, { Component, useState } from "react";
import ReactEcharts from "echarts-for-react";
import { TiInfoOutline } from "react-icons/ti";
import NoRecord from "app/Components/CommanComponents/NoRecord";
import { decimalPointNumber } from "app/_helpers/helper";

class EchartPieChart extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let {
      isClickAble,
      childfun,
      category,
      seriesName,
      tooltip,
      seriesData,
      xAxisName,
      yAxisName,
      labelFlag,
      customLabel,
      customLegend,
      pieChartColour,
      zoomActive,
      seriesOptions,
    } = this.props;

    if (Array.isArray(seriesData) && seriesData.length > 0) {
      seriesData = seriesData.map((data) => {
        if (data.value) {
          data.value = decimalPointNumber(data.value, 2);
        }
        return data;
      });
    }
    const pieColor = [
      "#28b873",
      "#f5cb39",
      "#e7404a",
      "#25cde8",
      "#E3701A",
      "#8B7500",
      "#CDC9A5",
      "#3237cb",
      "#d31bdf",
      "#3300FF",
      "#FF0066",
      "#DE8DF3",
      "#FF4500",
      "#7F00FF",
      "#5C5C9A",
      "#71A1E6",
      "#FF5733",
      "#33FF57",
      "#3357FF",
      "#FF33A6",
      "#33FFA6",
      "#A633FF",
      "#FFA633",
      "#FF3333",
      "#33FF33",
      "#3333FF",
      "#FFFF33",
      "#33FFFF",
      "#FF33FF",
      "#FF3366",
      "#3366FF",
      "#66FF33",
      "#6633FF",
      "#FF6633",
      "#336633",
      "#663333",
      "#333366",
      "#666633",
      "#663366",
      "#FF6699",
      "#6699FF",
      "#9966FF",
      "#FF9966",
      "#99FF66",
      "#66FF99",
      "#9966CC",
      "#66CC99",
      "#99CC66",
      "#CC9966",
      "#9966FF",
      "#CC66FF",
      "#FF66CC",
      "#66CCFF",
      "#CC66CC",
      "#66FFCC",
      "#CCFF66",
      "#CCFFCC",
      "#66CCCC",
      "#CCCC66",
      "#FFCCCC",
      "#CCCCFF",
      "#CC99FF",
      "#FF99CC",
      "#99CCFF",
      "#FF99FF",
      "#99FF99",
      "#99FFFF",
      "#9999FF",
      "#99FFCC",
      "#9999CC",
      "#99CCCC",
      "#CCCC99",
      "#CCCC33",
      "#999933",
      "#CC9933",
      "#339933",
      "#339999",
      "#3399CC",
      "#993399",
      "#9933CC",
      "#993366",
      "#6633CC",
      "#FF3333",
      "#CC3399",
      "#9933FF",
      "#333399",
      "#FF9933",
      "#CC6633",
      "#33CC33",
      "#33CC99",
      "#339933",
      "#CC3333",
      "#996633",
      "#336633",
      "#CC9966",
      "#669966",
      "#99FF33",
      "#FF9933",
      "#66FF66",
      "#FF66FF",
      "#CC3366",
      "#FF6666",
      "#663366",
      "#99FF66",
      "#669933",
      "#336666",
      "#666699",
      "#FF3366",
      "#336699",
      "#33CC66",
      "#33FF99",
      "#66CC66",
      "#FF3366",
      "#33CC99",
      "#99FF99",
      "#FF99CC",
      "#FFCC33",
      "#66CC99",
      "#CC99CC",
      "#993399",
      "#FF9933",
      "#CC33FF",
      "#33FFCC",
      "#CCFF33",
      "#CCFF99",
      "#FF66CC",
      "#996699",
      "#FF99FF",
      "#66CC33",
      "#FF66CC",
      "#66FF99",
      "#99CC33",
      "#CC6699",
      "#9933CC",
      "#33CCCC",
      "#FF6699",
      "#66CCFF",
      "#FF3366",
      "#66CC33",
      "#99FFCC",
      "#33FF66",
      "#CCFF66",
      "#FF99FF",
      "#CC66FF",
      "#FF33CC",
      "#CC66CC",
      "#FFCC66",
      "#CC9966",
      "#9933FF",
      "#CC99FF",
      "#FFCC99",
      "#CC99FF",
      "#99CCFF",
      "#FFCC33",
      "#CCFF66",
      "#FF33FF",
      "#CC99CC",
      "#FF99CC",
      "#99FF33",
      "#FF33CC",
      "#99FF66",
      "#FF6666",
      "#99FF99",
      "#FF9999",
      "#99CC99",
      "#99CC66",
      "#CC6666",
      "#CC9999",
      "#996666",
      "#6666FF",
      "#6699FF",
      "#9966FF",
      "#6633FF",
      "#3366FF",
      "#6699CC",
      "#66CCFF",
      "#66FFCC",
      "#99FFFF",
      "#33FFFF",
      "#33FF33",
      "#99FF66",
      "#FFCC99",
      "#CC9999",
      "#CCFF99",
    ];

    console.log(pieColor);

    console.log(pieColor);

    const echartBasicPie = {
      tooltip: tooltip ? tooltip : false,
      color: pieChartColour ? [...pieChartColour] : [...pieColor],
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      legend: customLegend ? customLegend : false,
      xAxis: [
        {
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
      ],
      yAxis: [
        {
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
      ],

      series: [
        {
          name: seriesName ? seriesName : "value",
          type: "pie",
          radius: zoomActive && seriesOptions ? seriesOptions?.radius : "67%",
          center: zoomActive && seriesOptions ? seriesOptions?.center : ["50%", "50%"],
          data: seriesData ? seriesData : [],
          bottom: zoomActive ? "18%" : 20,
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
              formatter: "{b} \n{c} ({d}%)",
            },
          },
          label: customLabel
            ? customLabel
            : {
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: "13",
                    fontWeight: "bold",
                  },
                  formatter: "{b} \n{c} ({d}%)",
                },
              },
        },
      ],
    };

    return (
      <React.Fragment>
        {Array.isArray(seriesData) && seriesData.length > 0 ? (
          <ReactEcharts
            style={{ height: zoomActive ? "650px" : "300px" }}
            option={echartBasicPie}
            onEvents={{ click: (e) => (isClickAble ? childfun(e) : "") }}
          />
        ) : (
          <NoRecord />
        )}
      </React.Fragment>
    );
  }
}

export default EchartPieChart;
